import { PropsWithChildren, useState } from 'react'
import { Checkbox, Stack, styled, Typography } from '@mui/material'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Entity, usePermissions } from 'utils/hooks'
import { Axios } from 'utils'
import { useQuery, useQueryClient } from 'react-query'
import useConfirmModal, {
  confirmModalTextStyles,
} from '../dialogs/useConfirmModal'

export const Container = styled('div')<{ active: boolean }>`
  width: 300px;
  max-height: 56px;
  display: flex;
  align-items: center;
  padding: 0px 10px;
  background: #f9f9f9;
  border-radius: 6px;
  justify-content: space-between;
  font-size: 15px;
  cursor: pointer;
  svg {
    fill: ${({ active }) => (active ? '#36c24c' : '#CACACA')};
  }
`

const linkSilos = async ({ queryKey }) => {
  const [_, id, binId] = queryKey
  const response = await Axios.get(`silos/${id}/link_to_bin/${binId}`)
  return response.data
}

const unlinkSilos = async ({ queryKey }) => {
  const [_, id, binId] = queryKey
  const response = await Axios.get(`silos/${id}/unlink_from_bin`)
  return response.data
}

interface Props {
  active?: boolean
  binId: number
  id: number
  isDisabled: boolean
  bin_id: number
}

export function SilosItem({
  id,
  binId,
  bin_id,
  active,
  children,
  isDisabled,
}: PropsWithChildren<Props>) {
  const queryClient = useQueryClient()
  const { checkPermission } = usePermissions()
  // NOTE: maybe ask be to request using PUT instead of GET
  const { data, refetch: refetchLink } = useQuery(
    ['link-silos', id, binId],
    linkSilos,
    {
      refetchOnWindowFocus: false,
      enabled: false,
      onSuccess: () => {
        queryClient.invalidateQueries(['fetch-silos'])
      },
    }
  )

  const [renderSiloToggleConfirm, toogleSiloConfirm] = useConfirmModal({
    onConfirm: () => {},
    title: 'Attention!',
    content: (
      <Stack>
        <Typography sx={confirmModalTextStyles}>
          You have disconnected a silo from an Equinom bin.
        </Typography>
        <Typography sx={confirmModalTextStyles}>
          Are you sure you would like to continue with this disconnect?
        </Typography>
      </Stack>
    ),
  })

  const { refetch: refetchUnlink } = useQuery(
    ['unlink-silos', id, binId],
    unlinkSilos,
    {
      refetchOnWindowFocus: false,
      enabled: false,
      onSuccess: () => {
        queryClient.invalidateQueries(['fetch-silos'])
      },
    }
  )

  const toggle = async (checked) => {
    if (checked) {
      toogleSiloConfirm({
        onProceed: async () => {
          await refetchUnlink()
        },
      })
    } else {
      await refetchLink()
    }
  }

  const isActive = !!bin_id

  return (
    <Container active={isDisabled ? false : isActive}>
      <Typography sx={isDisabled ? { color: '#D3D3D3' } : { color: 'black' }}>
        {children}
      </Typography>
      <Checkbox
        disabled={
          isDisabled ||
          (isActive
            ? !checkPermission(Entity.SILOS, 'unlink')
            : !checkPermission(Entity.SILOS, 'link'))
        }
        // checked={isChecked}
        checked={isActive}
        onClick={() => toggle(isActive)}
        icon={<RadioButtonUncheckedIcon />}
        checkedIcon={<CheckCircleIcon />}
      />
      {renderSiloToggleConfirm}
    </Container>
  )
}
